import  { useEffect, useRef, useState } from 'react';
import { Grid, Button, FormControl, TextField, Autocomplete,Select, MenuItem, InputAdornment, RadioGroup, InputLabel, FormControlLabel, Radio, Checkbox, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Chip } from '@mui/material';
import './part-timer-style.scss'
import { employeeBankUpdate, employeeResumeUpdate, employeePhotosUpdate, employeeProfile, employeeProfilesUpdate, getEmployeeBankDetails, sendOtp, verifyOtp, employeeDeleteAccount } from '../../sevices/account';
import { Modal,Spin} from 'antd';
// import{Spin} from 'antd';
import { ReactComponent as UncheckIcon } from '../../assets/images/radio-uncheck.svg';
import { ReactComponent as CheckIcon } from '../../assets/images/radio-check.svg';
import { MuiOtpInput } from 'mui-one-time-password-input';
import DoneIcon from '@mui/icons-material/Done';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { removeItemFrmLocalStorage, isEmptyObj } from '../../utils/genericUtilities';
import CustomSnackBar from '../../shared/snackBar';
import { VALIDATION_MSG } from '../../constant';
import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import { JobCertification, JobSkillSet } from '../../sevices/job';

const ASPECT_RATIO = 16 / 9;
const indianLanguages = [
    "Asami",
    "Bengali",
    "Gujarati",
    "Hindi",
    "Kannada",
    "Malayalam",
    "Marathi",
    "Odia",
    "Punjabi",
    "Tamil",
    "Telugu",
    "Urdu",
    "Sanskrit",
    "English",
    "Konkani",
    "Nepali",
    "Bodo",
    "Kashmiri",
    "Maithili",
    "Santali",
    "Sindhi"
];

// IMAGE CROP FUNCTION 
function centerAspectCrop(
    mediaWidth,
    mediaHeight,
    aspect
) {
    return centerCrop(
        makeAspectCrop(
            {
                unit: '%',
                width: 90,
            },
            aspect,
            mediaWidth,
            mediaHeight,
        ),
        mediaWidth,
        mediaHeight,
    )
}
// USER PROFILE FUNCTION 

const PartTimerUserProfileComponent = ({ setProfilePhoto, profilePhoto }) => {
    const [profileData, setprofileData] = useState('')
    const [selectedResume, setSelectedResume] = useState(null);

    const [visible, setVisible] = useState(false);
    const [profilevisible, setProfileVisible] = useState(false);
    const [aboutvisible, setaboutVisible] = useState(false);
    const [bankVisible, setBankVisible] = useState(false);
    const [checkedItems, setCheckedItems] = useState([]);
    const [numberVerified, setNumberVerified] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [previewResume, setPreviewResume] = useState(null);

    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState('');
    const [otpResponse, setOtpResponse] = useState('')
    const [phone, setPhone] = useState('');
    const [firstname, setfirstname] = useState('')
    const [lastname, setlastname] = useState('')
    const currentDate = dayjs();
    const defaultDate = currentDate.subtract(18, 'year');
    const [selectedLanguages, setSelectedLanguages] = useState([]);

    const [dob, setdob] = useState('');
    const [email, setemail] = useState('')
    const [gender, setgender] = useState('')
    const [language, setlanguage] = useState([])
    const [address, setaddress] = useState('')
    const [city, setcity] = useState('')
    const [state, setstate] = useState('')
    const [pincode, setpincode] = useState('')
    const [education, seteducation] = useState('')
    const [college, setcollege] = useState('')
    const [university, setuniversity] = useState('')
    const [yearoafpassing, setyearoafpassing] = useState('')
    const [fieldeducation, setfieldeducation] = useState('')
    const [experincedetails, setexperincedetails] = useState('')
    const [experincecategory, setexperincecategory] = useState('')
    const [about, setabout] = useState('')
    const [loading, setloading] = useState(false)
    const [photo, setphoto] = useState('')
    const [resumeStatus, setResumeStatus] = useState(false)

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [customMsg, setCustomMsg] = useState({});
    const navigate = useNavigate();
    const [errorPopupOpen, setErrorPopupOpen] = useState(false);
    const [errorMessage, setSrrorMessage] = useState('');
    // for bank details
    const [panNumber, setPanNumber] = useState('')

    const [accountNumber, setAccountNumber] = useState('')
    const [accountHolderName, setAccountHolderName] = useState('')
    const [ifscCode, setIfscCode] = useState('')
    const [bankDetails, setBankDetails] = useState({})
    const [bankDetailsUpdated, setBankDetailsUpdated] = useState(false)

    const [differentlyAbled, setDifferentlyAbled] = useState();
    const [open, setOpen] = useState(false);
    const [openCrop, setOpenCrop] = useState(false);

    const [certification, setCertification] = useState([]);
    const [selectedCertification, setSelectedCertification] = useState(['']);
    const imageRef = useRef(null)
    const [experienceDetails, setExperienceDetails] = useState([]);
    const [currentExperienceDetails, setCurrentExperienceDetails] = useState({ field: "", job_title: "" });
    const [isEdit, setIsEdit] = useState(false);
    const [editIndex, setEditIndex] = useState(0);
    const [crop, setCrop] = useState();
    const [completedCrop, setCompletedCrop] = useState(null);
    const [jobSkills, setJobSkills] = useState([]);
    const [skillsValue, setSkillsValue] = useState([]);
    const [selectedSkills, setSelectedSkills] = useState('');
    const [SkillError, setSkillError] = useState('')
    const [educationError, seteducationError] = useState('')
    const [collegeError, setcollegeError] = useState('')
    const [universityError, setuniversityError] = useState('')
    const [yearError, setyearError] = useState('')
    const [photoError, setPhotoError] = useState('')

    const aadharnum = '';
    const accountType = '';
    const fielldError = '';
    const skils = [];
    const badWords = [];



// POPUP FUNCTION 
    const ErrorPopup = () => {
        return (
            <Dialog open={errorPopupOpen} onClose={() => setErrorPopupOpen(false)}>
                <DialogTitle>Error</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {errorMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setErrorPopupOpen(false)}>OK</Button>
                </DialogActions>
            </Dialog>
        );
    };
 
// SNACKBAR FUNCTION 
    const handleSnackbarClick = (status, msgInfo) => {
        setOpenSnackbar(status);
        !isEmptyObj(msgInfo) && setCustomMsg(msgInfo);
    };
// LOGOUT FUNCTION 
    const handleLogout = () => {
        removeItemFrmLocalStorage(['token', 'currentUser'])
        navigate("/")
    }
    // LANGUAGE FUNCTION
    const handleLanguageChange = (_event, value) => {
        setSelectedLanguages(value);
        setlanguage(value);
    };
    // CHECKBOX FUNCTION 
    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        if (checked) {
            setCheckedItems((PrevState) => Array.isArray(PrevState) ? [...PrevState, name] : [name]);

        } else {
            setCheckedItems(checkedItems?.filter((item) => item !== name));
        }
    };
    const checkboxData = [
        { id: 'communication', label: 'Communication' },
        { id: 'technical', label: 'Technical' },
        { id: 'marketing', label: 'Marketing' },
        { id: 'leadership', label: 'Leadership' },
        { id: 'interpersonal', label: 'Interpersonal' },
        { id: 'sales', label: 'Sales' },
        { id: 'teamwork', label: 'Teamwork' },
        { id: 'customer_service', label: 'Customer service' },
        { id: 'analytical', label: 'Analytical' },
        { id: 'creative_design', label: 'Creative or Design' },
        { id: 'financial_analysis', label: 'Financial analysis' },
        { id: 'data analysis', label: 'Data analysis' },
        { id: 'Project_management', label: 'Project management' },
        { id: 'research', label: 'Research' },
        { id: 'writing_editing', label: 'Writing and editing' },
    ];



// CERTIFICATION LIST API FUNCTION 

    const GetCertificationList = async (_event) => {
        const body = {
            status: 1
        }
        const response = await JobCertification(body);
        setCertification(response?.data?.items)
    };
    // JOB SKILL API FUNCTION 
    const getJobSkill = async (_event) => {
        const body = {
            status: 1
        }
        const response = await JobSkillSet(body);
        setJobSkills(response?.data?.items)
    };
    // CERTIFICATION FUNCTION 
    const handleCertificationChange = (_event, value) => {

        const uniqueCertifications = value
            .map(Certification => Certification)
            .filter((Certification, index, self) => self.indexOf(Certification) === index);
        const containsBadWord = uniqueCertifications.findIndex(Certification => {
            return badWords.some(badWord => Certification.includes(badWord));
        });
        if (containsBadWord > -1) {
            uniqueCertifications.splice(containsBadWord, 1);
        }

        // setCertificationValue(uniqueCertifications)
        setSelectedCertification(uniqueCertifications);
        // const valuesNotInCertificationSet = uniqueCertifications.filter(Certification => !certification.map(s => s.name).includes(Certification));
        // setNewCertificationValues(valuesNotInCertificationSet);
        // setCertificationError('')
    };
    // CERTIFICATION CHARACTER VALIDATION FUNCTION 
    const handleCertificationKeyDown = (event) => {
        const isValidChar = /^[a-zA-Z0-9\s]+$/.test(event.key);

        const isBackspace = event.key === 'Backspace';
        if ((event?.target?.value?.length >= 50 && !isBackspace) || (!isValidChar && !isBackspace)) {
            event.preventDefault();
        }

    };
    // SKILLS FUNCTION
    const handleSkillsChange = (_event, value) => {

        const uniqueSkills = value
            .map(skill => skill)
            .filter((skill, index, self) => self.indexOf(skill) === index);
        const containsBadWord = uniqueSkills.findIndex(skill => {
            return badWords.some(badWord => skill.includes(badWord));
        });
        if (containsBadWord > -1) {
            uniqueSkills.splice(containsBadWord, 1);
        }

        setSkillsValue(uniqueSkills || [])
        setSelectedSkills(uniqueSkills || '');
        // const valuesNotInSkillSet = uniqueSkills.filter(skill => !jobSkills.map(s => s.name).includes(skill));
        // setNewSkillValues(valuesNotInSkillSet);
        setSkillError('')
    };
    // SKILL CHARACTER VALIDATION FUNCTION 
    const handleSkillsKeyDown = (event) => {
        const isValidChar = /^[a-zA-Z0-9\s]+$/.test(event.key);

        const isBackspace = event.key === 'Backspace';
        if ((event?.target?.value?.length >= 50 && !isBackspace) || (!isValidChar && !isBackspace)) {
            event.preventDefault();
        }
    };
// EMPLOYEE BANK DETAILS API FUNCTION 
    const getBankDetails = async () => {
        try {
            const response = await getEmployeeBankDetails();

            const data = response?.data
            if (data && Object.keys(data)?.length !== 0 && data.details && Object.keys(data.details)?.length !== 0) {
                setBankDetailsUpdated(true)
                setBankDetails(data.details);
                setAccountNumber(data?.details?.account_number);
                setAccountHolderName(data?.details?.beneficiary_name);
                setIfscCode(data?.details?.ifsc_code);
            }

        } catch (error) {
            handleSnackbarClick(true, { type: 'error', msg: 'Something Went Wrong' })
        }
    };
    // EMPLOYEE PROFILE API FUNCTION 
    const fetchJobData = async () => {
        try {
            const employee = await employeeProfile({});

            const data = employee?.data?.details
            const employeePhoto = employee?.data
            setphoto(employeePhoto)

            // setCertificates(employee?.data?.certificate ?? 'dfdffd')
            setfirstname(data?.first_name)
            setlastname(data?.last_name)
            setPhone(data?.phone)
            setdob(data?.dob)
            setemail(data?.email)
            setgender(data?.gender)
            setlanguage(data?.language_known)
            if (data?.language_known?.length > 0) {
                setSelectedLanguages(data?.language_known)

            }
            if (data?.resume) {
                setPreviewResume(`${photo?.meta?.resume?.path}/${photo?.meta?.resume?.folder}/${profileData?.resume}`)
            }
            setaddress(data?.address)
            setcity(data?.city)
            setstate(data?.state)
            setpincode(data?.pincode)
            setprofileData(data)
            seteducation(data?.education_qualification)
            setcollege(data?.college_name)
            setuniversity(data?.University)
            setyearoafpassing(data?.year_of_passing)
            setfieldeducation(data?.field_of_education)
            setexperincedetails(data?.field_of_experience)
            setexperincecategory(data?.experience_category || '')
            setDifferentlyAbled(data?.differently_abled)
            // certification_details
            setSelectedCertification(data?.certification_details || [])

            // const skillArray = skilValue.split(',')

            setExperienceDetails(data?.experience_details)
            setSkillsValue(data?.skills || [])
            setCheckedItems(data?.experience_list)
            setabout(data?.about_you)
            // setphotoload(false)
        } catch (error) {
            handleSnackbarClick(true, { type: 'error', msg: 'Something Went Wrong' })
        }
    };

// MODAL SHOW FUNCITON 
    const showModal = () => {
        setVisible(true);
    };
    // BANK MODAL SHOW FUNCTION 
    const showBankModal = () => {
        setBankVisible(true);
    };
    // BANK MODAL HIDE FUNCTION 
    const hideBankModal = () => {
        setBankVisible(false);
    };
 // MODAL HIDE FUNCTION 
    const hideModal = () => {
        setVisible(false);
    };
// MODAL PROFILE SHOW FUNCTION 
    const showModalprofile = () => {
        setProfileVisible(true);
    };
// MODAL PROFILE HIDE FUNCTION 

    const hideModalprofile = () => {
        setProfileVisible(false);
    };
// MODAL ABOUT HIDE FUNCTION 

    const hideModalabout = () => {
        setaboutVisible(false);
    };
// SEND OTP API FUNCTION 
    const otpSend = async () => {
        const data = {
            "phone": `+91${phone}`
        }
        try {
            const response = await sendOtp(data);
            if (response?.status === 200) {
                setOtpSent(true)
                setOtpResponse(response?.data?.details)
            } 
        } catch (err) {
            handleSnackbarClick(true, { type: 'error', msg: 'Something Went Wrong' })
        }
    }
    //  VALUE SET FUNCTION 
    const handleChange = (fieldName) => (event) => {
        if (fieldName === 'phone') {
            const value = event.target.value;
            if (value?.length <= 10) {
                setPhone(value);
            }
        }
        if (fieldName === 'otp') {
            setOtp(event);
        }
    };

   // VERIFIY OTP FUNCTION 

    const otpVerify = async () => {

        const data = {
            phone: otpResponse.to,
            otp,
            serviceSid: otpResponse.serviceSid
        }
        try {
            const response = await verifyOtp(data);
            if (response?.status === 200) {
                if (response?.data?.details?.valid) {
                    setNumberVerified(response?.data?.details?.valid)
                } else {
                    handleSnackbarClick(true, { type: 'error', msg: 'Enter Valid OTP' })
                    setOtpSent(false)
                }

            } 
        } catch (err) {

            handleSnackbarClick(true, { type: 'error', msg: 'Something Went Wrong' })
        }
    }
// DATE CHANGE FORMAT FUNCTION 
    const handleDateChange = (date) => {
        const inputDate = new Date(date);
        const formattedDate = `${inputDate.getFullYear()}-${(inputDate.getMonth() + 1).toString().padStart(2, '0')}-${inputDate.getDate().toString().padStart(2, '0')}`;
        setdob(formattedDate);
    };
    //DISABLE DATE FUNCTION
    const shouldDisableDate = (date) => {
        return date.isAfter(defaultDate, 'day');
    };
    // UPDATE BANK DETAILS API FUNCTION 
    const handleUpdateBank = async () => {

        if (!accountNumber || !accountHolderName || !ifscCode) {
            handleSnackbarClick(true, { type: 'error', msg: 'Please provide all required bank details' });
            return;
        }

        if (!accountNumber) {
            handleSnackbarClick(true, { type: 'error', msg: 'Please provide account number' });
            return;
        }
        if (!accountHolderName) {
            handleSnackbarClick(true, { type: 'error', msg: 'Please provide account holder name' });
            return;
        }
        if (!ifscCode) {
            handleSnackbarClick(true, { type: 'error', msg: 'Please provide IFSC code' });
            return;
        }
        if (!panNumber) {
            handleSnackbarClick(true, { type: 'error', msg: 'Please provide Pan Number' });
            return;
        }
        const bankDetailsData = {
            "account_number": accountNumber,
            "account_type": accountType,
            "account_holder_name": accountHolderName,
            "IFSC_code": ifscCode,
            "pan_number": panNumber
        };
        setloading(true)
        try {
            const response = await employeeBankUpdate(bankDetailsData)
            if (response?.status === 200) {
                setloading(false)
                setBankVisible(false)
                fetchJobData()
            }

        } catch (error) {

            setloading(false)
            if (error?.response?.data?.error?.description) {
                handleSnackbarClick(true, { type: 'error', msg: error?.response?.data?.error?.description })
            } else {
                handleSnackbarClick(true, { type: 'error', msg: 'Something Went Wrong' })
            }
        }

    }
// EMPLOYEE PROFILE UPDATE API FUNCTION
    const handleupdate = async () => {


        if (educationError || yearError || collegeError || universityError) {
            return
        }


        const body = {}
        body.first_name = firstname
        body.last_name = lastname
        body.pincode = pincode
        body.dob = dob
        body.language_known = language
        body.gender = gender
        body.state = state
        body.email = email
        body.city = city
        body.address = address
        body.aadhar_number = aadharnum
        body.education_qualification = education
        body.college_name = college
        body.University = university
        body.year_of_passing = yearoafpassing
        body.field_of_education = fieldeducation
        body.field_of_experience = experincedetails
        body.experience_category = experincecategory
        body.about_you = about
        body.experience_list = checkedItems
        body.phone = phone
        body.differently_abled = differentlyAbled
        body.certification_details = selectedCertification
        body.skills = skillsValue;
        body.experience_details = experienceDetails;


        setloading(true)
        try {
            const response = await employeeProfilesUpdate(body)
            if (response?.status === 200) {
                // setphotoload(true)
                setloading(false)
                setVisible(false)
                fetchJobData()
                setProfileVisible(false);
                setaboutVisible(false);
            }

        } catch (error) {
            if (error?.response?.data?.errors[0]?.rules[0]?.message) {
                setSrrorMessage(error?.response?.data?.errors[0]?.rules[0]?.message);
                setErrorPopupOpen(true);
                setloading(false)

            } else {
                setSrrorMessage("somthing went wrong");
                setErrorPopupOpen(true);
                setloading(false)
            }

        }



        // let userid = profileData.id
        // const formData = new FormData();
        // formData.append('photo', selectedFile);
        // const updatePHOTO = await employeePhotosUpdate(formData, userid)


        //setloading(true)

        // }    

        if (resumeStatus) {

            try {

                const formData = new FormData();
                formData.append('resume', selectedResume);
                const updateReasume = await employeeResumeUpdate(formData)

                if (updateReasume?.status === 200) {
                    fetchJobData()
                }
                setloading(true)
            } catch (err) {
                 // continue regardless of error
            }
        }

    }
    // IMAGE FILE FUNCTION 
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!allowedTypes.includes(file.type)) {
                // setCompanyLogoError('Only JPG, JPEG and PNG files are allowed.');
                // Clear the file input
                // setFileInputKey(Date.now());

                return;
            } else {
                setPhotoError('')
                setPreviewImage(URL.createObjectURL(file));
                setOpenCrop(true);
            }

        }
    };

    // RESUME UPLOAD FUNCTION 
    const handleResumeUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedResume(file);
            setResumeStatus(true);
            try {
                const objectURL = URL.createObjectURL(file);
                setPreviewResume(objectURL);
            } catch (error) {
                 // continue regardless of error
            }
        }
    };

    // const onLoad = useCallback((img) => {
    //     setImgRef(img);
    // }, []);

// IMAGE LOAD FUNCTION 
    function onImageLoad(e) {
        if (ASPECT_RATIO) {
            const { width, height } = e.currentTarget
            setCrop(centerAspectCrop(width, height, ASPECT_RATIO))
        }
    }

// EMPLOYEE IMAGE UPDATE API FUNCTION 


    const getCroppedImg =  () => {
        setOpenCrop(false)
        const image = imageRef.current;

        if (!image || !completedCrop) {

            return;
        }

        const cropWidth = image.naturalWidth * (crop.width / 100);
        const cropHeight = image.naturalHeight * (crop.height / 100);
        const startX = image.naturalWidth * (crop.x / 100);
        const startY = image.naturalHeight * (crop.y / 100);

        const canvas = document.createElement('canvas');
        canvas.width = cropWidth;
        canvas.height = cropHeight;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
            console.error('No 2d context');
            return;
        }


        ctx.drawImage(
            image,
            startX,
            startY,
            cropWidth,
            cropHeight,
            0,
            0,
            cropWidth,
            cropHeight
        );


        canvas.toBlob(async (blob) => {
            if (!blob) {
                console.error('Canvas to blob conversion failed');
                return;
            }

            try {
                const formData = new FormData();
                formData.append('photo', blob);

                // Assuming profileData.id is available
                const userid = profileData.id;
                const updatePHOTO = await employeePhotosUpdate(formData, userid);
                if (updatePHOTO?.status === 200) {
                    setProfilePhoto(Date.now())
                    // fetchJobData();
                    setOpenCrop(false);
                } else {
                    console.error('Failed to update photo', updatePHOTO);
                }
            } catch (error) {
                console.error('Error uploading photo', error);
            }
        }, 'image/png', 'image/jpg', 'image/jpeg');
    };


// TEXT REGEX FUNCTION 
    const handleTextInput = (event) => {
        const regex = /^[A-Za-z ]+$/;
        if (!regex.test(event.target.value)) {
            event.target.value = event.target.value.replace(/[^A-Za-z ]+/g, '');
        }
    };

// EDUCATION VALIDATION FUNCTION 
    const validateEducationQualification = (event) => {
        const inputValue = event.target.value;

        if (!inputValue) {
            seteducationError(VALIDATION_MSG.educationRequired);
        } else {
            seteducationError('')
        }
        seteducation(inputValue);
    };
    // COLLEGE VALIDATION FUNCTION 
    const validatecollege = (event) => {

        const inputValue = event.target.value;

        if (!inputValue) {
            setcollegeError(VALIDATION_MSG.Required);
        } else {
            setcollegeError('')
        }
    };
    // UNIVERSITY VALIDATION FUNCTION 

    const validateuniversity = (event) => {

        const inputValue = event.target.value;

        if (!inputValue) {
            setuniversityError(VALIDATION_MSG.Required);
        } else {
            setuniversityError('')
        }
        setuniversity(inputValue);
    };
    // YEAR VALIDATION FUNCTION 

    const validateyearofpssing = (event) => {

        const inputValue = event.target.value;

        if (!inputValue) {
            setyearError(VALIDATION_MSG.Required);
        } else {
            setyearError('')
        }
        setyearoafpassing(inputValue);
    };
    // OPEN FUNCTION 
    const handleClickOpen = () => {
        setOpen(true);
    };
// CLOSE FUNCTION 
    const handleClose = () => {
        setOpen(false);
    };
// EMPLOYEE DELETE API FUNCTION 
    const deleteEmployeeAccount = async () => {
        try {
            const response = await employeeDeleteAccount();
            if (response.status === 200) {
                handleSnackbarClick(true, { type: 'success', msg: "Your account deleted successfully" })
                removeItemFrmLocalStorage(['token', 'currentUser'])
                navigate("/")
            }

        } catch (error) {
            handleSnackbarClick(true, { type: 'error', msg: error?.response?.data?.message })
        }
    };
// PHONE REGEX FUNCTION 
    const handleChangePhone = (event) => {
        const value = event.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        if (numericValue.length <= 10) {
            setPhone(numericValue);
        }
    };
    // UPDATE EXPERINECE FUNCTION 
    const updateExperenceData = (key, value) => {
        setCurrentExperienceDetails(prevState => ({
            ...prevState,
            [key]: value
        }));
    };
    // ADD EXPERIENCE FUNCTION 
    const addExperience = () => {
        if (currentExperienceDetails?.field && currentExperienceDetails?.job_title) {
            if (experienceDetails?.length > 0) {
                setExperienceDetails(prevItems => [...prevItems, currentExperienceDetails]);

            } else {
                setExperienceDetails([currentExperienceDetails])
            }
            setCurrentExperienceDetails({ field: "", job_title: "" });
        }
    };
    // UPDATE EXPERIENCE FUNCTION 
    const UpdateExperience = (index) => {
        if (currentExperienceDetails?.field && currentExperienceDetails?.job_title) {
            setExperienceDetails(prevItems =>
                prevItems.map((item, i) =>
                    i === index ? currentExperienceDetails : item
                )
            );
            setIsEdit(false)
            setCurrentExperienceDetails({ field: "", job_title: "" });
        }
    };
    // DELETE EXPERIENCE FUNCTION 

    const deleteExperience = (index) => {
        setExperienceDetails(prevItems => prevItems.filter((_, i) => i !== index));
    };

    useEffect(() => {
        fetchJobData();
        getBankDetails()
        GetCertificationList();
        getJobSkill();
        // if (jobSkills?.length && update === true) {
        const employeeSkills = skils.filter(skill => jobSkills.some(jobSkill => jobSkill.name === skill));

        setSkillsValue(employeeSkills || []);
        // }
    }, [loading])

    return (
        <div className="userProfilePage">
            {loading && (
                <div className="SiginLoader">
                    <Spin spinning />
                </div>
            )}
            <Grid container spacing={2.5} justifyContent={'center'}>
                <Grid item xs={12} sm={12} lg={10}>
                    <div className="profileMainCard">
                        <div className="profileEditCard">
                            <div className="userInfoContainer">
                                {profileData?.employee_photo ? <img src={`${photo?.meta?.employee_photo?.path}/${photo?.meta?.employee_photo?.folder}/${photo?.meta?.employee_photo?.sizes?.medium}/${profileData?.employee_photo}?time=${profilePhoto}`} className="userImg" alt=""/>
                                    : <img
                                        src={require('../../assets/images/user.png')}
                                        className="userImg"
                                        alt=""
                                    />}

                                <div className="userInfoContent">
                                    <div className="userName">{firstname} {lastname}</div>
                                    <div className="userName"/>

                                    <div className="infoContent">
                                        {about}
                                    </div>
                                </div>
                                <Button title='Edit' onClick={() => setaboutVisible(true)} className="editBtn">
                                    <span>Edit</span>
                                    <img title='Edit' src={require('../../assets/images/edit-icon-2.png')} alt=""/>
                                </Button>
                            </div>
                            <div className="userSkilsContainer">
                                {checkedItems && checkedItems?.length > 0 ? checkedItems.map((itemId) => {
                                    const itemLabel = checkboxData.find((checkbox) => checkbox.id === itemId).label;
                                    return (
                                        <div key={itemId} className="userSkilSet">
                                            <strong>{itemLabel}</strong>
                                        </div>
                                    );
                                }) : null}
                            </div>
                        </div>
                        <div className="profileEditCard">
                            <div className="titleContainer">
                                <div className="title">Profile</div>
                                <Button title='Edit' className="editBtn" onClick={showModalprofile}  >
                                    <span>Edit</span>
                                    <img title='Edit' src={require('../../assets/images/edit-icon-2.png')} alt=""/>
                                </Button>
                            </div>
                            <Modal

                                open={aboutvisible}
                                onOk={hideModalabout}
                                onCancel={hideModalabout}
                                className="profile-edit-modal PartTimerRegistrationPage"
                                width={800}
                                footer={[
                                    <Button key="cancel" className="cancel-btn" onClick={hideModalabout}>
                                        Cancel
                                    </Button>,
                                    <Button key="update" className="update-btn" onClick={handleupdate} type="primary">
                                        Update
                                    </Button>
                                ]}
                            >
                                <div className="scrollableContainer registrationWizard">
                                    <div className="WizardFormContainer">
                                        <div className="title"> Profile Update</div>
                                        <form>
                                            <Grid container spacing={5}>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        id="outlined-uncontrolled"
                                                        label="Upload profile image"
                                                        className="form-control fileAttachmentInput"
                                                        InputLabelProps={{ shrink: true }}
                                                        type="file"

                                                        // value='iii'
                                                        InputProps={{

                                                            // defaultValue: 'vff',

                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <AttachFileIcon />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        inputProps={
                                                            { accept: 'image/jpeg, image/png, image/svg, image/jpg' }
                                                        }
                                                        onChange={handleFileChange}
                                                    />
                                                    {photoError && (
                                                        <div className="text-danger">
                                                            ajdhfhadhfgadfgagd
                                                        </div>
                                                    )}
                                                    <div className="uploadedImage">
                                                        {/* {previewImage && (
                                                            <img src={previewImage} alt="Preview" style={{ maxWidth: '100%', marginTop: '10px' }} />
                                                        )} */}
                                                        {/* {(profileData?.employee_photo || previewImage) ? <img src={previewImage || `${photo?.meta?.employee_photo?.path}/${photo?.meta?.employee_photo?.folder}/${photo?.meta?.employee_photo?.sizes?.medium}/${profileData?.employee_photo}?time=${Date()}`} className="userImg" />
                                                            : null} */}
                                                    </div>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <textarea
                                                        rows={8}
                                                        style={{ height: '160px', width: '100%', borderRadius: '7px' }}
                                                        // className="form-control"
                                                        value={about}
                                                        onChange={(e) => setabout(e.target.value)}
                                                        placeholder="Write a description about you"
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <div className="title">Experience Details</div>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <RadioGroup
                                                        aria-labelledby="demo-radio-buttons-group-label"
                                                        value={experincecategory}
                                                        onChange={e => setexperincecategory(e.target.value)}

                                                        name="radio-buttons-group"
                                                        className="experienceRadio"
                                                    >
                                                        <FormControlLabel value="fresher" control={<Radio icon={<UncheckIcon />}
                                                            checkedIcon={<CheckIcon />} />} label="Fresher" />
                                                        <FormControlLabel value="experienced" control={<Radio icon={<UncheckIcon />}
                                                            checkedIcon={<CheckIcon />} />} label="Experienced" />
                                                    </RadioGroup>
                                                </Grid>
                                                {experincecategory === 'experienced' && <Grid item xs={12} sm={12}>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} sm={4.3}>
                                                            <TextField
                                                                id="field_of_experience"
                                                                label="Field of experience"
                                                                name='field_of_experience'
                                                                className="form-control"
                                                                type="text"
                                                                value={currentExperienceDetails.field}
                                                                onInput={handleTextInput}
                                                                onChange={(e) => updateExperenceData('field', e.target.value)}
                                                                inputProps={{
                                                                    maxLength: 60,
                                                                    // pattern: "[^A-Za-z0-9 ]+",
                                                                }}
                                                                InputProps={{
                                                                    type: 'text',

                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={4.3}>
                                                            <TextField
                                                                id="job_title"
                                                                label="Job title"
                                                                name='job_title'
                                                                className="form-control"
                                                                type="text"
                                                                value={currentExperienceDetails.job_title}
                                                                onInput={handleTextInput}
                                                                onChange={(e) => updateExperenceData('job_title', e.target.value)}
                                                                inputProps={{
                                                                    maxLength: 60,
                                                                    // pattern: "[^A-Za-z0-9 ]+",
                                                                }}
                                                                InputProps={{
                                                                    type: 'text',

                                                                }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} sm={3.4}>
                                                            {!isEdit ? <Button className='experenceButton' variant="outlined" onClick={() => addExperience()}>
                                                                <span>Add Experience</span>
                                                            </Button> : <Button className='experenceButton' variant="outlined" onClick={() => UpdateExperience(editIndex)}>
                                                                <span>Update Experience</span>
                                                            </Button>}
                                                        </Grid>
                                                        {experienceDetails && experienceDetails?.map((data, index) => (
                                                            <Grid key={index} item xs={12} sm={5}>
                                                                <div className='experenceCard'>
                                                                    <div className='card-info'>
                                                                        <b>Field:</b> {data?.field}
                                                                    </div>
                                                                    <div className='card-info'>
                                                                        <b>Job title:</b> {data?.job_title}
                                                                    </div>
                                                                    <div className='cardBtnContainer'>
                                                                        <Button title='Edit' className="editBtn" onClick={() => {
                                                                            setIsEdit(true)
                                                                            setEditIndex(index);
                                                                            setCurrentExperienceDetails(data);
                                                                        }}>
                                                                            <img title='Edit' src={require('../../assets/images/icon-edit.png')} alt=""/>
                                                                            <span>Edit</span>
                                                                        </Button>
                                                                        <Button title='Edit' className="editBtn deleteBtn" onClick={() => deleteExperience(index)} >
                                                                            <img title='Edit' src={require('../../assets/images/icon-delete.png')} alt=""/>
                                                                            <span>Delete</span>
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </Grid>
                                                        ))}

                                                    </Grid>
                                                </Grid>}
                                                <Grid item xs={12} sm={12}>
                                                    <FormControl>
                                                        <div className="experienceCheckBoxContainer">
                                                            <div className="experienceCheckBoxBind">
                                                                {checkedItems && checkedItems?.map((itemId) => {
                                                                    const foundCheckbox = checkboxData?.find((checkbox) => checkbox?.id === itemId);
                                                                    const label = foundCheckbox?.label || 'Label not found';
                                                                    return (
                                                                        <div key={itemId} className="checkBoxTag">
                                                                            {label}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                            <div className="experienceCheckBox">
                                                                {checkedItems && checkedItems?.length > 0 && checkedItems && checkedItems ? (checkboxData?.map((checkbox) => (
                                                                    <FormControlLabel
                                                                        key={checkbox?.id}
                                                                        control={
                                                                            <Checkbox
                                                                                checked={checkedItems?.includes(checkbox?.id)}
                                                                                onChange={handleCheckboxChange}
                                                                                name={checkbox?.id}
                                                                            />
                                                                        }
                                                                        label={checkbox.label}
                                                                    />)
                                                                )) : checkboxData?.map((checkbox) => (
                                                                    <FormControlLabel
                                                                        key={checkbox?.id}
                                                                        control={
                                                                            <Checkbox
                                                                                checked={checkedItems?.includes(checkbox?.id)}
                                                                                onChange={handleCheckboxChange}
                                                                                name={checkbox?.id}
                                                                            />
                                                                        }
                                                                        label={checkbox?.label}
                                                                    />))}
                                                            </div>
                                                        </div>
                                                    </FormControl>
                                                </Grid>
                                                {/* <Grid item xs={12} sm={12}>
                                                    <div>Certification</div>
                                                </Grid> */}

                                                <Grid item xs={12} sm={12}>
                                                    <p>Certification</p>

                                                    <Autocomplete
                                                        multiple
                                                        id="tags-filled"
                                                        options={[...certification?.map((skill) => skill.name), ...selectedCertification]}
                                                        freeSolo
                                                        value={selectedCertification}

                                                        onChange={handleCertificationChange}
                                                        className="form-control"
                                                        renderInput={(params) => (
                                                            <TextField {...params}
                                                                variant="outlined"
                                                                // label="Certification" 
                                                                onKeyDown={handleCertificationKeyDown} />
                                                        )}
                                                        filterSelectedOptions
                                                    />
                                                    {/* {CertificationError && <p className='errorMsg'>{CertificationError}</p>} */}

                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    {/* <div>Skills</div> */}
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <p>Skills</p>

                                                    <Autocomplete
                                                        multiple
                                                        id="tags-filled"
                                                        options={[...jobSkills?.map((skill) => skill.name), ...selectedSkills]}
                                                        freeSolo
                                                        value={skillsValue}
                                                        onChange={handleSkillsChange}
                                                        className="form-control"
                                                        renderInput={(params) => (
                                                            <TextField {...params} variant="outlined"
                                                                // label="Skills" 
                                                                onKeyDown={handleSkillsKeyDown} />
                                                        )}
                                                        filterSelectedOptions
                                                    />
                                                    {SkillError && <p className='errorMsg'>{SkillError}</p>}

                                                </Grid>

                                            </Grid>
                                        </form>
                                    </div>
                                </div>
                            </Modal>

                            <Modal
                                open={profilevisible}
                                onOk={hideModalprofile}
                                onCancel={hideModalprofile}
                                className="profile-edit-modal PartTimerRegistrationPage"
                                width={1000}
                                footer={[
                                    <Button key="cancel" className="cancel-btn" onClick={hideModalprofile}>
                                        Cancel
                                    </Button>,
                                    <Button key="update" className="update-btn" onClick={handleupdate} type="primary">
                                        Update
                                    </Button>
                                ]}
                            >
                                <div className="scrollableContainer registrationWizard">
                                    <div className="WizardFormContainer">
                                        <div className="title">Personal Information</div>
                                        <form>
                                            <Grid container spacing={5}>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        id="first_name"
                                                        label="First name"
                                                        name='first_name'
                                                        className="form-control"
                                                        type="text"
                                                        value={firstname}
                                                        onInput={handleTextInput}
                                                        onChange={(e) => setfirstname(e.target.value)}
                                                        inputProps={{
                                                            maxLength: 50,
                                                            pattern: "[^A-Za-z0-9 ]+",
                                                        }}
                                                        InputProps={{
                                                            type: 'text',

                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        id="last_name"
                                                        label="Last name"
                                                        name='last_name'
                                                        className="form-control"
                                                        onInput={handleTextInput}
                                                        value={lastname}
                                                        onChange={(e) => setlastname(e.target.value)}
                                                        inputProps={{
                                                            maxLength: 50,
                                                            pattern: "[^A-Za-z0-9 ]+",
                                                        }}
                                                        InputProps={{
                                                            type: 'text',
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        id="name-input"
                                                        name='email'
                                                        variant="outlined"
                                                        value={email}
                                                        label="Email"

                                                        inputProps={{
                                                            maxLength: 50,
                                                            pattern: "^[^A-Za-z ]$",

                                                        }}
                                                        type='email'
                                                        onChange={(e) => setemail(e.target.value)}
                                                        InputProps={{
                                                            type: 'text',
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>

                                                    {
                                                        numberVerified ? (
                                                            <TextField
                                                                id="phone_numbvver"
                                                                label="Phone numbeaar"
                                                                className="form-control"
                                                                value={phone}
                                                                InputProps={{
                                                                    type: 'text',
                                                                    maxLength: 10,
                                                                    // pattern: '[0-9]*',
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <DoneIcon className="phoneVerifyIcon" />
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        ) : otpSent ? (
                                                            <div className="verifyOtpInput">
                                                                <MuiOtpInput value={otp}
                                                                    onChange={handleChange("otp")}
                                                                />
                                                                <Button className="phoneVerifyBtn"
                                                                    onClick={otpVerify}
                                                                >
                                                                    Enter OTP
                                                                </Button>
                                                            </div>
                                                        ) : (
                                                            <TextField
                                                                id="phone_number"
                                                                label="Phone number"
                                                                className="form-control"
                                                                value={phone}
                                                                onChange={handleChangePhone}
                                                                InputProps={{
                                                                    // type: 'number',
                                                                    maxLength: 10,
                                                                    pattern: '[0-9]*',
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <Button className="phoneVerifyBtn"
                                                                                onClick={otpSend}
                                                                            >
                                                                                Verify
                                                                            </Button>
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                        )
                                                    }
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DemoContainer components={['DatePicker']}>
                                                            <DatePicker defaultValue={dob ? dayjs(dob) : null} name='dob' onChange={handleDateChange} label="Date of birth" shouldDisableYear={shouldDisableDate} disableFuture slotProps={{
                                                                textField: {
                                                                    readOnly: true,
                                                                },
                                                            }} />
                                                        </DemoContainer>
                                                    </LocalizationProvider>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="type_of_company">Gender</InputLabel>
                                                        <Select
                                                            labelId="type_of_company"
                                                            id="demo-simple-select"
                                                            className="form-control"
                                                            label="Gender"

                                                            value={gender}
                                                            onChange={e => setgender(e.target.value)}
                                                        >
                                                            <MenuItem value={"Male"}>Male</MenuItem>
                                                            <MenuItem value={"Female"}>Female</MenuItem>
                                                            <MenuItem value={"Others"}>Others</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Autocomplete
                                                        multiple
                                                        id="tags-outlined"
                                                        options={indianLanguages}
                                                        onChange={(event, newValue) => {
                                                            handleLanguageChange(event, newValue);
                                                        }}
                                                        value={selectedLanguages}
                                                        renderOption={(props, option) => {
                                                            return (
                                                                <li {...props} key={option}>
                                                                    {option}
                                                                </li>
                                                            )
                                                        }}
                                                        renderTags={(tagValue, getTagProps) => {
                                                            return tagValue.map((option, index) => (
                                                                <Chip {...getTagProps({ index })} key={option} label={option} />
                                                            ))
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Language known"
                                                                placeholder=""
                                                            />
                                                        )}
                                                    />

                                                </Grid>
                                                <Grid item xs={12} sm={6} className="differently-radio-box">
                                                    <label htmlFor="pickup-drop-radio-group" style={{ marginLeft: '10px', fontSize: '14px', fontWeight: '400', color: '#605757' }} >Differently-abled</label>
                                                    <RadioGroup
                                                        aria-labelledby="demo-radio-buttons-group-label"
                                                        defaultValue="differently-abled"
                                                        name="radio-buttons-group"
                                                        className="picukpradio differently-radio"
                                                        value={differentlyAbled}
                                                        onChange={(e) => setDifferentlyAbled(e.target.value)}
                                                    >
                                                        <FormControlLabel value="true" control={<Radio icon={<UncheckIcon />}
                                                            checkedIcon={<CheckIcon />} />} label="Yes" />
                                                        <FormControlLabel value="false" control={<Radio icon={<UncheckIcon />}
                                                            checkedIcon={<CheckIcon />} />} label="No" />
                                                    </RadioGroup>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <TextField
                                                        id="confirm_password"
                                                        label="Address"
                                                        value={address}
                                                        inputProps={{
                                                            maxLength: 50,
                                                            pattern: "^[^A-Za-z ]$",
                                                        }}
                                                        className="form-control"
                                                        onChange={(e) => setaddress(e.target.value)}

                                                        name='address'

                                                        InputProps={{
                                                            type: 'text',
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        id="city"
                                                        label="City"
                                                        value={city}
                                                        className="form-control"
                                                        onInput={handleTextInput}
                                                        inputProps={{
                                                            maxLength: 50,
                                                            pattern: "[^A-Za-z0-9 ]+",
                                                        }}
                                                        onChange={(e) => setcity(e.target.value)}

                                                        InputProps={{
                                                            type: 'text',
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="type_of_company">State</InputLabel>
                                                        <Select
                                                            labelId="State"
                                                            id="demo-simple-select"
                                                            className="form-control"
                                                            label="State"
                                                            value={state}

                                                            onChange={(e) => setstate(e.target.value)}
                                                        >
                                                            <MenuItem value={'Andhra Pradesh'}>Andhra Pradesh</MenuItem>
                                                            <MenuItem value={"Arunachal Pradesh"}>Arunachal Pradesh</MenuItem>
                                                            <MenuItem value={"Assam"}>Assam</MenuItem>
                                                            <MenuItem value={'Bihar'}>Bihar</MenuItem>
                                                            <MenuItem value={'Chhattisgarh'}>Chhattisgarh</MenuItem>
                                                            <MenuItem value={'Goa'}>Goa</MenuItem>
                                                            <MenuItem value={"Haryana"}>Haryana</MenuItem>
                                                            <MenuItem value={"Himachal Pradesh"}>Himachal Pradesh</MenuItem>
                                                            <MenuItem value={"Jharkhand"}>Jharkhand</MenuItem>
                                                            <MenuItem value={"Karnataka"}>Karnataka</MenuItem>
                                                            <MenuItem value={"Kerala"}>Kerala</MenuItem>
                                                            <MenuItem value={"Madhya Pradesh"}>Madhya Pradesh</MenuItem>
                                                            <MenuItem value={"Maharashtra"}>Maharashtra</MenuItem>
                                                            <MenuItem value={"Manipur"}>Manipur</MenuItem>
                                                            <MenuItem value={"Meghalaya"}>Meghalaya</MenuItem>
                                                            <MenuItem value={"Mizoram"}>Mizoram</MenuItem>
                                                            <MenuItem value={"Nagaland"}>Nagaland</MenuItem>
                                                            <MenuItem value={"Punjab"}>Punjab</MenuItem>
                                                            <MenuItem value={"Pondicherry"}>Pondicherry</MenuItem>
                                                            <MenuItem value={"Rajasthan"}>Rajasthan</MenuItem>
                                                            <MenuItem value={"Odisha"}>Odisha</MenuItem>
                                                            <MenuItem value={"Sikkim"}>Sikkim</MenuItem>
                                                            <MenuItem value={"Tamil Nadu"}>Tamil Nadu</MenuItem>
                                                            <MenuItem value={"Telangana"}>Telangana</MenuItem>
                                                            <MenuItem value={"Tripura"}>Tripura</MenuItem>
                                                            <MenuItem value={"Uttar Pradesh"}>Uttar Pradesh</MenuItem>
                                                            <MenuItem value={"Uttarakhand"}>Uttarakhand</MenuItem>
                                                            <MenuItem value={"West Bengal"}>West Bengal</MenuItem>

                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        id="pincode-input"
                                                        label="Pincode"
                                                        variant="outlined"
                                                        type="number"
                                                        // maxLength={6}
                                                        value={pincode}
                                                        onChange={(e) => setpincode(e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 6))}

                                                        inputProps={{
                                                            maxLength: 6,
                                                        }}
                                                    />
                                                </Grid>


                                                {previewResume ? null : <Grid item xs={12} sm={12}>
                                                    <TextField onChange={event => handleResumeUpload(event)}
                                                        id="outlined-uncontrolled"
                                                        label="Upload your resume"
                                                        className="form-control fileAttachmentInput"
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{
                                                            type: 'file',
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <AttachFileIcon />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Grid>}

                                            </Grid>
                                        </form>
                                    </div>
                                </div>
                            </Modal>
                            <div className="fullWidth">
                                <Grid container spacing={2.5}>
                                    <Grid item xs={12} sm={3}>
                                        <div className="infoSet">
                                            <span>First name</span>
                                            <strong>{firstname}</strong>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <div className="infoSet">
                                            <span>Last name</span>
                                            <strong>{lastname}</strong>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <div className="infoSet">
                                            <span>Email Id</span>
                                            <strong>{email}</strong>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <div className="infoSet">
                                            <span>Mobile number</span>
                                            <strong>{phone}</strong>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <div className="infoSet">
                                            <span>Date of birth</span>
                                            <strong>{dayjs(dob, "YYYY-MM-DD").format("DD-MM-YYYY")}</strong>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <div className="infoSet">
                                            <span>Gender</span>
                                            <strong>{gender}</strong>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <div className="infoSet">
                                            <span>Languages known</span>
                                            <strong>{language?.join(', ')}</strong>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <div className="infoSet">
                                            <span>Address</span>
                                            <strong>{address}</strong>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <div className="infoSet">
                                            <span>State</span>
                                            <strong>{state}</strong>
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                        <div className="profileEditCard">
                            <div className="titleContainer">
                                <div className="title">Educational Details</div>
                                <Button title='Edit' className="editBtn" onClick={showModal}  >
                                    <span>Edit</span>
                                    <img title='Edit' src={require('../../assets/images/edit-icon-2.png')} alt=""/>
                                </Button>
                            </div>
                            <div className="fullWidth">
                                <Grid container spacing={2.5}>
                                    <Grid item xs={12} sm={4}>
                                        <div className="infoSet">
                                            <span>Highest education qualification</span>
                                            <strong>{education}</strong>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <div className="infoSet">
                                            <span>Name of the instutite</span>
                                            <strong>{college}</strong>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <div className="infoSet">
                                            <span>University</span>
                                            <strong>{university}</strong>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <div className="infoSet">
                                            <span>Year of passing or perusing</span>
                                            <strong>{yearoafpassing}</strong>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <div className="infoSet">
                                            <span>Field of education</span>
                                            <strong>{fieldeducation}</strong>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <div className="infoSet">
                                            <span>Experience details</span>
                                            <strong>{experincecategory}</strong>
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>

                        <div className="profileEditCard">
                            <div className="titleContainer">
                                <div className="title">Bank Details</div>
                               {!bankDetailsUpdated? <Button disabled={bankDetailsUpdated} title='Edit' className="editBtn" onClick={showBankModal}  >
                                    <span>Edit</span>
                                    <img title='Edit' src={require('../../assets/images/edit-icon-2.png')} alt=""/>
                                </Button>:null}
                            </div>
                            <div className="fullWidth">
                                <Grid container spacing={2.5}>
                                    <Grid item xs={12} sm={4}>
                                        <div className="infoSet">
                                            <span>IFSC code</span>
                                            <strong>{bankDetails?.ifsc_code}</strong>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <div className="infoSet">
                                            <span>Account Holder Name</span>
                                            <strong>{bankDetails?.beneficiary_name}</strong>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <div className="infoSet">
                                            <span>Account Number</span>
                                            <strong>{bankDetails?.account_number}</strong>
                                        </div>
                                    </Grid>
                                    {/* <Grid item xs={12} sm={4}>
                                        <div className="infoSet">
                                            <span>Pan Number</span>
                                            <strong>{bankDetails?.Pan_number}</strong>
                                        </div>
                                    </Grid> */}
                                </Grid>
                            </div>
                        </div>

                        <Modal
                            open={visible}
                            onOk={hideModal}
                            onCancel={hideModal}
                            className="profile-edit-modal PartTimerRegistrationPage"
                            width={1000}
                            footer={[
                                <Button key="cancel" className="cancel-btn" onClick={hideModal}>
                                    Cancel
                                </Button>,
                                <Button key="update" className="update-btn" onClick={handleupdate} type="primary">
                                    Update
                                </Button>
                            ]}
                        >
                            <div className="scrollableContainer registrationWizard">
                                <div className="WizardFormContainer">
                                    <div className="title">Educational Details</div>
                                    <form>
                                        <Grid container spacing={5}>
                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    id="company_name"
                                                    label="Highest education qualification"
                                                    className="form-control"
                                                    error={Boolean(educationError)}
                                                    helperText={educationError}
                                                    onInput={handleTextInput}
                                                    inputProps={{
                                                        maxLength: 50,
                                                        pattern: "[^A-Za-z0-9 ]+",
                                                    }}

                                                    onBlur={validateEducationQualification}
                                                    value={education}
                                                    onChange={e => seteducation(e.target.value)}
                                                    InputProps={{
                                                        type: 'text',
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <div className="subTitle">College</div>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    id="company_website"
                                                    label="Name of the instutite"
                                                    error={Boolean(collegeError)}
                                                    helperText={collegeError}
                                                    onBlur={validatecollege}
                                                    onInput={handleTextInput}
                                                    inputProps={{
                                                        maxLength: 50,
                                                        pattern: "[^A-Za-z0-9 ]+",
                                                    }}
                                                    value={college}
                                                    onChange={e => setcollege(e.target.value)}
                                                    className="form-control"
                                                    InputProps={{
                                                        type: 'text',
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    id="company_address"
                                                    label="University"
                                                    onInput={handleTextInput}
                                                    inputProps={{
                                                        maxLength: 50,
                                                        pattern: "[^A-Za-z0-9 ]+",
                                                    }}
                                                    value={university}
                                                    error={Boolean(universityError)}
                                                    helperText={universityError}
                                                    onBlur={validateuniversity}
                                                    onChange={e => setuniversity(e.target.value)}
                                                    className="form-control"
                                                    InputProps={{
                                                        type: 'text',
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    id="state"
                                                    label="Year of passing or perusing"
                                                    type="number"
                                                    value={yearoafpassing}
                                                    onChange={(e) => {
                                                        const inputValue = e.target.value;
                                                        if (inputValue === "" || /^\d+$/.test(inputValue)) {
                                                            setyearoafpassing(
                                                                inputValue === "" ? "" : Math.max(0, parseInt(inputValue)).toString().slice(0, 4)
                                                            );
                                                        }
                                                    }}
                                                    error={Boolean(yearError)}
                                                    helperText={yearError}
                                                    onBlur={validateyearofpssing}
                                                    className="form-control"
                                                    InputProps={{
                                                        type: "text",
                                                    }}
                                                />

                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    id="city "
                                                    label="Field of education "
                                                    className="form-control"
                                                    // onInput={handleTextInput}
                                                    error={Boolean(fielldError)}
                                                    helperText={fielldError}
                                                    // onBlur={validatefield}
                                                    value={fieldeducation}
                                                    onChange={e => setfieldeducation(e.target.value.replace(/[^A-Za-z ]+/g, ''))}
                                                    InputProps={{
                                                        type: 'text',
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                        <Modal
                            open={bankVisible}
                            onOk={hideBankModal}
                            onCancel={hideBankModal}
                            className="profile-edit-modal PartTimerRegistrationPage"
                            width={1000}
                            footer={[
                                <Button key="cancel" className="cancel-btn" onClick={hideBankModal}>
                                    Cancel
                                </Button>,
                                <Button key="update" className="update-btn" onClick={handleUpdateBank} type="primary">
                                    Update
                                </Button>
                            ]}
                        >
                            <div className="scrollableContainer registrationWizard">
                                <div className="WizardFormContainer">
                                    <div className="title">Bank Details</div>
                                    <form>
                                        <Grid container spacing={5}>
                                            {!bankDetailsUpdated ? (
                                                <Grid item xs={12} sm={12}>
                                                    <TextField
                                                        id="PanNumber"
                                                        label="PAN Number"
                                                        className="form-control"
                                                        variant="outlined"
                                                        value={panNumber}
                                                        onChange={(e) => {
                                                            const inputVal = e.target.value.toUpperCase();
                                                            setPanNumber(inputVal);
                                                        }}
                                                        onBlur={() => {
                                                            const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
                                                            if (!panRegex.test(panNumber)) {
                                                                alert("Invalid PAN number. Please enter a valid PAN.");
                                                                setPanNumber("");

                                                            }
                                                        }}
                                                        type="text"
                                                        inputProps={{
                                                            maxLength: 10,
                                                            pattern: "[A-Z]{5}[0-9]{4}[A-Z]{1}",
                                                        }}
                                                    />
                                                </Grid>
                                            ) : null}
                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    id="account_number"
                                                    label="Account number"
                                                    className="form-control"
                                                    variant="outlined"
                                                    value={accountNumber}
                                                    onChange={(e) => {
                                                        const inputVal = e.target.value;
                                                        if (inputVal?.length <= 17 && /^\d*$/.test(inputVal)) {
                                                            setAccountNumber(inputVal);
                                                        }
                                                    }}
                                                    type="text" // Use type="text" instead of type="number"
                                                    maxLength={50}
                                                    pattern="[0-9]*"
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    id="account_holder_name"
                                                    label="Account holder name"
                                                    className="form-control"
                                                    variant="outlined"
                                                    value={accountHolderName}
                                                    onChange={(e) => setAccountHolderName(e.target.value.replace(/[^A-Za-z ]/ig, ''))}
                                                    inputProps={{
                                                        maxLength: 50,

                                                    }}
                                                    InputProps={{
                                                        type: 'text',
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <div className="ifsc-code-container">
                                                    <TextField
                                                        id="ifsc_code"
                                                        label="IFSC code"
                                                        className="form-control"
                                                        variant="outlined"
                                                        value={ifscCode}
                                                        onChange={(e) => setIfscCode(e.target.value.replace(/[^A-Za-z0-9]/ig, ''))}

                                                        inputProps={{
                                                            maxLength: 11,

                                                        }}

                                                        InputProps={{
                                                            type: 'text',
                                                        }}
                                                        fullWidth
                                                    />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                        <Dialog open={openCrop} onClose={() => setOpenCrop(false)} maxWidth="md" fullWidth>
                            <DialogTitle>Crop Image</DialogTitle>
                            <DialogContent>
                                {previewImage && (

                                    <ReactCrop
                                        crop={crop}
                                        onChange={(_, percentCrop) => setCrop(percentCrop)}
                                        onComplete={(c) => setCompletedCrop(c)}
                                    >
                                        <img src={previewImage} ref={imageRef} onLoad={onImageLoad} alt=""/>
                                    </ReactCrop>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setOpenCrop(false)} color="secondary">
                                    Cancel
                                </Button>
                                <Button color="primary" onClick={() => getCroppedImg()} disabled={!completedCrop}>
                                    Upload
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Grid item xs={12} sm={12} sx={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            justifyContent: 'space-between'
                        }}>
                            <Button onClick={handleClickOpen} className="logoutBtn">
                                <DeleteOutlinedIcon />
                                <span>Delete Account</span>
                            </Button>
                            <Button onClick={handleLogout} className="logoutBtn">
                                <img src={require('../../assets/images/logout.png')} alt="" />
                                <span>Logout</span>
                            </Button>

                        </Grid>
                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete your account? This action cannot be undone.
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleClose}>Cancel</Button>
                                <Button onClick={deleteEmployeeAccount} autoFocus>
                                    Delete
                                </Button>
                            </DialogActions>
                        </Dialog>

                    </div>
                </Grid>
            </Grid>
            {
                openSnackbar ? <CustomSnackBar
                    openSnackbar={openSnackbar}
                    snackBarMessage={customMsg?.msg}
                    status={customMsg?.type}
                    handleSnackbarClick={handleSnackbarClick}
                /> : null
            }
            <ErrorPopup />
        </div >
    )
}
export default PartTimerUserProfileComponent;